import React, { useState, useEffect } from "react";
import { Carousel } from "antd";
// import LazyBanner from "./lazyBanner";

const contentStyle: React.CSSProperties = {
  width: "100%",
  height: "526px",
  background: "#f5f6f7",
};

const contentStyle2: React.CSSProperties = {
  width: "100%",
  height: "360px",
  background: "#f5f6f7",
};

const shuffleArray = <T,>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const Banner: React.FC = () => {
  const initialImages = [
    {
      src: "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/banner/crafts4-pc.webp",
      src2: "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/banner/crafts4.webp",
      alt: "Batik, Crafts, and Souvenirs",
    },
    {
      src: "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/banner/japan-natural2-pc.webp",
      src2: "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/banner/japan-natural2.webp",
      alt: "Experiencing Japan's Natural Beauty Year-Round",
    },
    {
      src: "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/banner/historic-sites4-pc.webp",
      src2: "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/banner/historic-sites4.webp",
      alt: "The Great Wall and Beyond: Historic Sites",
    },
    {
      src: "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/banner/tokyo-nights1-pc.webp",
      src2: "https://creative.cdn.apm.any-digital.com/h5/exploreAsia/banner/tokyo-nights1.webp",
      alt: "Tokyo Nights: Best Evening Spots",
    },
  ];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [activeIndex, setActiveIndex] = useState(0);
  const [images] = useState(() => shuffleArray(initialImages));
  // const [loadedImages, setLoadedImages] = useState(new Set<number>());

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setActiveIndex((prevIndex) => Math.min(prevIndex, images.length - 1));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [images.length]);

  const handleBeforeChange = (current: number, next: number) => {
    setActiveIndex(next);
    // setLoadedImages((prev) => new Set(prev).add(next));
  };

  // 新增: 计算有效的预加载索引范围
  const getAdjacentIndices = (current: number, max: number) => {
    return [
      current > 0 ? current - 1 : current,
      current,
      current < max ? current + 1 : current,
    ];
  };
  // 在渲染逻辑中：
  const validIndices = getAdjacentIndices(activeIndex, images.length - 1);

  return (
    <div className="overflow-hidden">
      <Carousel autoplay beforeChange={handleBeforeChange}>
        {images.map((image, index) => (
          <div
            key={index}
            className={validIndices.includes(index) ? "block" : "hidden"}
          >
            <h3 style={windowWidth > 800 ? contentStyle : contentStyle2}>
              <picture>
                <source
                  // srcSet={image.src.replace(".webp", ".avif")}
                  srcSet={image.src}
                  type="image/avif"
                />
                <source
                  srcSet={windowWidth > 800 ? image.src : image.src2}
                  type="image/webp"
                />
                <img
                  src={windowWidth > 800 ? image.src : image.src2}
                  alt={image.alt}
                  className="w-full h-full object-cover"
                  loading={validIndices.includes(index) ? "eager" : "lazy"}
                />
              </picture>
            </h3>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Banner;
